
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(14961|80807)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
